import * as signalR from '@microsoft/signalr';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatLummySignalService {
  private hubConnection!: signalR.HubConnection;
  private tokenSession!: string;
  private hubUrl = environment.urlHub +'/api/chatLummyHubInMemory';
  public loaded: boolean = false;
  public startConnection(token: string) {
    this.loaded = false;
    //console.log('ReceiveToken = '  + this.tokenSession);
    this.hubConnection = new signalR.HubConnectionBuilder()
       .withUrl(`${this.hubUrl}`, {
        accessTokenFactory: () => token,  // Adiciona o token JWT
      })
      .build();

    this.hubConnection
      .start()
      .then(() => {console.log('Conexão com SignalR estabelecida')
        this.listenToTargetConnected();})
      .catch(err => console.log('Erro ao estabelecer conexão com SignalR: ' + err));
  }
  private listenToTargetConnected() {
    // Escutando o evento 'target connected' e atualizando a variável loaded
    this.hubConnection.on('Connected', () => {
      console.log('Target conectado!');
      this.loaded = true;  // Define como true quando o target estiver conectado
    });
  }
  public initializeConnection() {
    // Aqui você deve primeiro iniciar a conexão
    var tokenSession =  localStorage.getItem('authTokenLicitaAdmin');
    this.startConnection(this.tokenSession || tokenSession || ''); // Passa o token, se disponível

    // Define o que acontece quando um novo token é recebido
    this.hubConnection.on('ReceiveToken', (token: string) => {
      this.tokenSession = token; // Armazena o token JWT
      this.startConnection(this.tokenSession); // Reinicia a conexão com o novo token
    });
    // Define o que acontece quando uma mensagem é recebida
    this.hubConnection.on('ReceiveMessage', (user: string, message: string) => {
    });
  }

  // Método para enviar mensagens
  public sendMessage(user: string, message: string) {
    this.hubConnection.invoke('SendMessage', message)
      .catch(err => console.error('Erro ao enviar mensagem: ' + err));
  }


  // Método para encerrar a sessão de chat
  public endChat() {
    this.hubConnection.invoke('EndChat', this.tokenSession)
      .catch(err => console.error('Erro ao encerrar a sessão: ' + err));
  }

  public onReceiveMessage(callback: (user: string, message: string) => void): void {
    this.hubConnection.on('ReceiveMessage', (user: string, message: string) => {
      //console.log(`${user}: ${message}`);
      callback(user, message); // Chama o callback com os dados da mensagem
    });
  }

  public stopChatConnection() {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .then(() => console.log('Conexão do chat encerrada'))
        .catch(err => console.log('Erro ao encerrar conexão do chat: ' + err));
    } else {
      //console.log('Nenhuma conexão de chat ativa para encerrar.');
    }
  }
}
